import { render, staticRenderFns } from "./CurrencyItem.vue?vue&type=template&id=4ac5deb5&lang=true&"
import script from "./CurrencyItem.vue?vue&type=script&lang=js&"
export * from "./CurrencyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports